module.exports = __webpack_public_path__ + "img/awm.90ae542b.svg";